import { change } from 'redux-form';
import debounce from 'lodash/debounce';
import { filterHomePageGrid, refreshManagement, refreshSort } from '../state/gridActions';

/**
 * Legacy FilterBuilder onChange: debounced auto-search for non-admin grids.
 * Timing and branch conditions must stay identical to historical behavior.
 */
export const createLegacyAutoSearchOnChange = () =>
	debounce((values, dispatch, { gridName }) => {
		if (
			values &&
			(values.statusMGMT ||
				values.distDueMGMT ||
				values.sentDueMGMT ||
				values.statusReci ||
				values.distDueReci ||
				values.sentDueReci ||
				values.distributionDate ||
				values.reportType ||
				values.snTitle ||
				values.product ||
				values.study ||
				values.versionMGMT)
		) {
			return '';
		}
		const searchParam = (values && values.searchParam) || '';
		if (values && searchParam.length === 0) {
			if (values && (values.status || values.distDue || values.sentDue)) {
				dispatch(filterHomePageGrid(gridName, values));
			} else {
				dispatch(refreshManagement(gridName, (formName) => change(formName, 'searchParam', '')));
			}
		} else if (values && searchParam.length === 1) {
			if (values && (values.status || values.distDue || values.sentDue)) {
				dispatch(filterHomePageGrid(gridName, values));
			} else {
				return '';
			}
		} else if (values && searchParam.length >= 2) {
			dispatch(refreshSort(gridName, values));
		}
	}, 500);
